export enum NotificationSearchTypeEnum {
  UNREAD,
  ALL,
}
